import { classNames } from "@ember-decorators/component";
import icon from "discourse/helpers/d-icon";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const FutureDateInputSelectorRow = dt7948.c(class FutureDateInputSelectorRow extends SelectKitRowComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    {{#if this.item.icon}}\n      <div class=\"future-date-input-selector-icons\">\n        {{icon this.item.icon}}\n      </div>\n    {{/if}}\n\n    <span class=\"name\">{{this.label}}</span>\n\n    {{#if this.item.timeFormatted}}\n      <span class=\"future-date-input-selector-datetime\">\n        {{this.item.timeFormatted}}\n      </span>\n    {{/if}}\n  ", {
      strictMode: true,
      scope: () => ({
        icon
      })
    }), this);
  }
}, [classNames("future-date-input-selector-row")]);
export default FutureDateInputSelectorRow;